
export const GET_ALL_PRODUCT_OFFER_REQUEST = "GET_ALL_PRODUCT_OFFER_REQUEST";
export const GET_ALL_PRODUCT_OFFER_FAILURE = "GET_ALL_PRODUCT_OFFER_FAILURE";
export const GET_ALL_PRODUCT_OFFER_SUCCESS = "GET_ALL_PRODUCT_OFFER_SUCCESS";

export const CREATE_OFFER_REQUEST = "CREATE_OFFER_REQUEST";
export const CREATE_OFFER_FAILURE = "CREATE_OFFER_FAILURE";
export const CREATE_OFFER_SUCCESS = "CREATE_OFFER_SUCCESS";

export const UPDATE_OFFER_REQUEST = "UPDATE_OFFER_REQUEST";
export const UPDATE_OFFER_FAILURE = "UPDATE_OFFER_FAILURE";
export const UPDATE_OFFER_SUCCESS = "UPDATE_OFFER_SUCCESS";

export const DELETE_OFFER_REQUEST = "DELETE_OFFER_REQUEST";
export const DELETE_OFFER_FAILURE = "DELETE_OFFER_FAILURE";
export const DELETE_OFFER_SUCCESS = "DELETE_OFFER_SUCCESS";